import { render, staticRenderFns } from "./CardAlternativeCheeseLijst.vue?vue&type=template&id=17f7a514"
import script from "./CardAlternativeCheeseLijst.vue?vue&type=script&lang=js"
export * from "./CardAlternativeCheeseLijst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports